import client from '../../utils/api'
import { createSlice } from '@reduxjs/toolkit'
import { createApiAction } from '../../utils/redux-tool'

const name = 'nurseReport'
const initialState = {
    conditionList: null,
    conditionQuery: {},
    visitList: null,
    visitQuery: {},
    conditionLoading: false,
    visitLoading: false,
  }

export const searchCondition = createApiAction('conditionReport/search', client.search('/api/nurse/report/health-condition'))
export const searchVisit = createApiAction('visitReport/search', client.search('/api/nurse/report/visit'))

  const sessionSlice = createSlice({
    name,
    initialState,
    reducers: {
      setConditionQuery: (state, action) => {
        state.conditionQuery = action.payload
      },
      setVisitQuery: (state, action) => {
        state.visitQuery = action.payload
      },
    },
    extraReducers(builder) {
      builder
        .addCase(searchCondition.pending, (state) => {
          state.conditionLoading = true
        })
        .addCase(searchCondition.fulfilled, (state, action) => {
          state.conditionList = action.payload
          state.conditionLoading = false
        })
        .addCase(searchCondition.rejected, (state) => {
          state.conditionLoading = false
        })
        .addCase(searchVisit.pending, (state) => {
          state.visitLoading = true
        })
        .addCase(searchVisit.fulfilled, (state, action) => {
          state.visitList = action.payload
          state.visitLoading = false
        })
        .addCase(searchVisit.rejected, (state) => {
          state.visitLoading = false
        })
    },
  })

  export const { setConditionQuery, setVisitQuery } = sessionSlice.actions
  export default sessionSlice.reducer
